<template>
  <div class="customerinfo">
      <div class="top">
        <span class="customer">{{name}}</span>
        <el-button class="changeBtn" @click="linkToBench" size="mini">返回销售工作台</el-button>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick" class="wb_tabs info_tabs">
        <el-tab-pane label="客户信息" name="first">
          <info :customerInfo="customerInfo" :invoiceInfo="invoiceInfo"/>
        </el-tab-pane>
        <el-tab-pane label="回访记录" name="second" class="revisit_panel_box">   
          <returnrecord class="revisit_box" :revisitData="revisitData" :pages="pages" @pageChangeEvent="handlePageEvent" @operationEvent="handleOperationEvent">
            <!-- <slot start> -->
            <div class="search_box clearfix mar_top mar_bot">  
              <el-date-picker type="date" placeholder="回访开始时间" v-model="revisitParams.start_time" class="search_input search_inputBox" size="mini"></el-date-picker>
              <el-date-picker type="date" placeholder="回访结束时间" v-model="revisitParams.end_time" class="search_input search_inputBox" size="mini"></el-date-picker>
              <!-- <el-input class="search_input search_inputBox" v-model="dealParams.visit_content" placeholder="回访内容" size="mini"></el-input>   -->
              <div class="reset fcolor" @click="revisitReset">重置</div>
              <el-button class="publicBtn" @click="revisitSearch">查询</el-button>
            </div>
            <!-- </slot end> -->   
          </returnrecord>
        </el-tab-pane>
        <el-tab-pane label="成交记录" name="third" class="revisit_panel_box">
          <dealrecord :doneListData="doneListData" :donePages="donePages" :total_all="total_all" @dealPageChangeEvent="handleDealPageEvent">
            <div class="search_box clearfix mar_top mar_bot">
              <el-date-picker type="date" placeholder="成交开始时间" v-model="dealParams.start_time" class="search_input search_inputBox" size="mini"></el-date-picker>
              <el-date-picker type="date" placeholder="成交结束时间" v-model="dealParams.end_time" class="search_input search_inputBox" size="mini"></el-date-picker>     
              <el-select class="search_select search_inputBox" v-model="dealParams.settlement_status" placeholder="结算状态">
                <el-option v-for="list in settlementList" :key="list.id" :value="list.id" :label="list.name"></el-option>
              </el-select>
              <div class="reset fcolor" @click="dealReset">重置</div>
              <el-button class="publicBtn" @click="dealSearch">查询</el-button>
            </div>
          </dealrecord>
        </el-tab-pane>
      </el-tabs>
  </div>
</template>

<script>
import info from './info'
import returnrecord from './returnrecord'
import dealrecord from './dealrecord'
import eventBus from '../../../eventBus'

export default {
  components: {
    info,
    returnrecord,
    dealrecord
  },
  data(){
    return {
      activeName: 'second',
      customer_id: localStorage.getItem('dw_erp_customer_id'),
      name: localStorage.getItem('dw_erp_customer_name_workbench'),
      revisitData: [],
      doneListData: [],
      customerInfo: {},
      invoiceInfo: {},
      pages: {
        last_page: 0,
        total: 0,
        current_page: 1,
        per_page: 20
      },
      donePages: {
        last_page: 0,
        total: 0,
        current_page: 1,
        per_page: 20
      },
      revisitParams: {
        page: 1,
        per_page: 20,
        visit_content: '',
        start_time: '',
        end_time: '',
        customer_id: null
      },
      dealParams: {
        page: 1,
        per_page: 20,
        customer_id: null,
        settlement_status: null,
        start_time: '',
        end_time: ''
      },
      //成交记录 统计
      total_all: {
        total_count: 0,
        total_out_cube: 0,
        total_already_amount: 0,
        total_outstanding_amount: 0,
        total_invoice_not: 0
      },
      settlementList: [
        {id: 1, name: '未结算'},
        {id: 2, name: '部分结算'},
        {id: 3, name: '全部结算'},
      ]
    }
  },
  methods: {
    linkToBench(){
      localStorage.removeItem('dw_erp_customer_id')
      localStorage.removeItem('dw_erp_customer_name_workbench')
      this.$emit('fromInfo')
      eventBus.$emit('refreshTodoListFrom')
    },
    // tabs点击
    handleClick(){},
    //获取客户信息
    getCustomerInfo(){  
      this.postFunc("erp/customer.index.info",  {customer_id: this.customer_id}, res=>{
        this.customerInfo = res.data.data.basics
        this.invoiceInfo = res.data.data.invoice_information
      })
    },
    //获取回访记录
    getRevisitList(){
      let obj = Object.assign({}, this.revisitParams)
      obj.customer_id = Number(this.customer_id)
      obj.start_time = obj.start_time ? Date.parse(new Date(obj.start_time))/1000 : ''
      obj.end_time = obj.start_time ? (Date.parse(new Date(obj.end_time))/1000 + 86399) : ''
      this.postFunc("erp/customer.visit.list", obj, res=>{
        let resData = res.data.data.data
        resData.forEach(item=>{
          item.reminder_date = item.reminder_date ? this.formatTimeSecond(item.reminder_date*1000) : ''
          item.visit_time = item.visit_time ? this.formatTimeSecond(item.visit_time*1000) : ''
        })
        this.revisitData = resData
        let page = {}
        page.current_page = Number(res.data.data.current_page)
        page.last_page = res.data.data.last_page
        page.per_page = Number(res.data.data.per_page)
        page.total = res.data.data.total
        this.pages = page
      })
    },
    //获取成交记录
    getDoneList(){
      let obj = Object.assign({}, this.dealParams)
      obj.customer_id = Number(this.customer_id)
      obj.start_time = obj.start_time ? Date.parse(new Date(obj.start_time))/1000 : ''
      obj.end_time = obj.start_time ? (Date.parse(new Date(obj.end_time))/1000 + 86399) : ''
      this.postFunc('erp/customer.order.list', obj, res=>{
        let resData = res.data.data.data
        resData.forEach(item=>{
          item.out_time = item.out_time ? this.formatTimeSecond(item.out_time*1000) : ''
        })
        this.doneListData = res.data.data.data
        this.total_all = res.data.data.total_all
        let page = {}
        page.current_page = Number(res.data.data.current_page)
        page.last_page = res.data.data.last_page
        page.per_page = Number(res.data.data.per_page)
        page.total = res.data.data.total
        this.donePages = page
      })
    },
    //分页事件触发回调
    handlePageEvent(obj){
      if(this.revisitParams.per_page != obj.pagesize){
        this.revisitParams.per_page = obj.pagesize
        this.pages.per_page = obj.pagesize
      }
      if(this.revisitParams.page != obj.currentpage){
        this.revisitParams.page = obj.currentpage
        this.pages.current_page = Number(obj.currentpage)
      } 
    },
    //成交记录分页事件回调
    handleDealPageEvent(obj){
      if(this.dealParams.per_page != obj.pagesize){
        this.dealParams.per_page = obj.pagesize
        this.donePages.per_page = obj.pagesize
      }
      if(this.dealParams.page != obj.currentpage){
        this.dealParams.page = obj.currentpage
        this.donePages.current_page = Number(obj.currentpage)
      } 
    },
    //回访记录 操作事件回调
    handleOperationEvent(){
      this.getRevisitList()
    },
    revisitReset(){
      this.revisitParams.start_time = ''
      this.revisitParams.end_time = ''
      this.revisitParams.visit_content = ''
      this.revisitParams.page = 1
      this.getRevisitList()
    },
    revisitSearch(){
      this.revisitParams.page = 1
      this.getRevisitList()
    },
    dealReset(){
      this.dealParams.start_time = ''
      this.dealParams.end_time = ''
      this.dealParams.settlement_status = null
      this.dealParams.page = 1
      this.getDoneList()
    },
    dealSearch(){
      this.dealParams.page = 1
      this.getDoneList()
    }
  },
  async mounted(){
    this.customer_id =  await localStorage.getItem('dw_erp_customer_id')
    this.getRevisitList()
    this.getCustomerInfo()
    this.getDoneList()  
  },
  watch: {
    "revisitParams.page":function(){
      this.getRevisitList()
    },
    "revisitParams.per_page":function(){
      this.getRevisitList()
    },
    "dealParams.page":function(){
      this.getDoneList()
    },
    "dealParams.per_page":function(){
      this.getDoneList()
    },
  }
}
</script>

<style lang="scss" scoped>
.customerinfo{
  width: 100%;
  text-align: left;
  .top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 20px;
    .customer{
      font-weight: 600;
    }
  }
}
.customerinfo /deep/ .revisit_panel_box{
  display: flex;
  flex-direction: column;
  .mar_bot{
    margin-bottom: 10px;
  }
  .revisit_box{
    flex: 1;
  }
}
</style>